export default "__VITE_ASSET__BbI5bVPf__"